import { userClient } from "../clients/userClient"
import type {
  UserResponseDto,
  UpdateUserDto,
  UserListParams,
  UserListResponseDto,
} from "../types/user.types"

/**
 * User Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const userService = {
  /**
   * Get user by ID
   */
  getUserById: async (id: string): Promise<UserResponseDto> => {
    try {
      const user = await userClient.getUserById(id)
      return user
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List users with filters
   */
  getUsers: async (params?: UserListParams): Promise<UserListResponseDto> => {
    try {
      const response = await userClient.getUsers(params)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update user profile
   */
  updateUser: async (id: string, data: UpdateUserDto): Promise<UserResponseDto> => {
    try {
      const user = await userClient.updateUser(id, data)
      return user
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Toggle user active status
   */
  toggleUserActive: async (id: string, isActive: boolean): Promise<UserResponseDto> => {
    try {
      const user = await userClient.toggleUserActive(id, { isActive })
      return user
    } catch (error: any) {
      throw error
    }
  },
}

export default userService

